<template>
  <div class="shadow p-7 bg-white" :class="$attrs.class">
    <slot />
  </div>
</template>